import { useState } from 'react';

const useDialog = (props) => {
    const [showDialog, setShowDialog] = useState(props.showDialog);
    const [model, setModel] = useState(props.model || 'add');
    const [editItem, setEditItem] = useState({});

    const showAsEditModel = (item) => {
        setModel('edit');
        setEditItem(item);
        setShowDialog(true);
    };

    const showAsAddModel = () => {
        setModel('add');
        setEditItem({});
        setShowDialog(true);
    };

    const showAsCopyModel = (item) => {
        setEditItem(item);
        setModel('copy');
        setShowDialog(true);
    };

    const onClose = () => {
        setShowDialog(false);
    };

    const onSubmit = (data) => {
        if (props.onSubmit) {
            props.onSubmit(data);
        }
        setShowDialog(false);
    };

    const isEdit = () => model === 'edit';

    return {
        props: {
            show: showDialog,
            onClose,
            onSubmit,
            onCancel: onClose,
        },
        contentProps: {
            data: editItem,
            model,
        },
        showDialog,
        setShowDialog,
        model,
        showAsEditModel,
        showAsAddModel,
        showAsCopyModel,
        onClose,
        onSubmit,
        isEdit,
        editItem,
        onCancel: onClose,
    };
};

export default useDialog;
